import * as amplitude from '@amplitude/analytics-browser';
import { Inject, Injectable } from '@angular/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { Environment, ENVIRONMENT } from '@promojds-front/environments';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {

  constructor(
    private ccService: NgcCookieConsentService,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {
    this.initAmplitude()
    this.manageCookie()
  }

  private manageCookie(): void {
    this.ccService.statusChange$.subscribe(() => {
      amplitude.setOptOut(!this.ccService.hasConsented());
    })
  }

  private initAmplitude(): void {
    amplitude.init(this.environment.amplitudeApiKey, { 'autocapture': true });
    amplitude.setOptOut(!this.ccService.hasConsented());
  }
}
